module.exports = __webpack_public_path__ + "img/Rectangle 15238.7ad43761.svg";